import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TracesValidationViewModel } from '../../../core/_infrastructure/types/web.services';
import { EnvioTracesItemResultsViewModel, EnvioTracesItemViewModel, EnvioTracesViewModel } from './enviotraces.types';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ResetFiltersService } from 'src/app/components/core/_infrastructure/classes/services/reset-filters.service';

@Injectable()
export class EnvioTracesService extends ResetFiltersService {
    public currentFilterEnvioTraces = new EnvioTracesViewModel();

    constructor(
        protected authService: AuthService,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {
        super(authService);
    }

    getWEnvioTraces(id: number): Observable<EnvioTracesItemViewModel> {
        return this.http.get<EnvioTracesItemViewModel>(this.baseUrl + 'api/mantenimiento/enviotraces/' + id).pipe();
    }

    getEnvioTracesPagedByFilter(params: HttpParams): Observable<EnvioTracesItemResultsViewModel> {
        return this.http.get<EnvioTracesItemResultsViewModel>(this.baseUrl + 'api/mantenimiento/enviotraces/pagedbyfilter/', { params: params }).pipe();
    }

    export(model: EnvioTracesViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/mantenimiento/enviotraces/postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' })
            .pipe();
    }

    markToSend(idsolicitud: number): Observable<any> {
        return this.http.get<any>(this.baseUrl + 'api/mantenimiento/enviotraces/markToSend/' + idsolicitud).pipe();
    }

    Send(idsolicitud: number): Observable<TracesValidationViewModel> {
        return this.http
            .get<any>(this.baseUrl + 'api/mantenimiento/enviotraces/Send/' + idsolicitud, {
                headers: new HttpHeaders({ timeout: `${300000}` }),
            })
            .pipe();
    }

    resetFilter() {
        this.currentFilterEnvioTraces = new EnvioTracesViewModel();
    }
}
